export enum ScheduledReportPeriodicity{
    Weekly = 'weekly',
    Monthly = 'monthly'
}